import Swiper from "swiper/bundle";
import "swiper/css/bundle";

/**
 * Layout: Gerelateerde items
 * Slug: related_items
 */

const initRelatedItems = () => {
    document.querySelectorAll(".related_items-layout").forEach((layout) => {
        const swiperEl = layout.querySelector(".related-swiper");
        if (!swiperEl) return;

        new Swiper(swiperEl, {
            loop: false,
            watchOverflow: true,
            navigation: {
                prevEl: layout.querySelector(".arrow-prev"),
                nextEl: layout.querySelector(".arrow-next"),
            },
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Vorige",
                nextSlideMessage: "Volgende",
                slideLabelMessage: "Slide {{index}} van {{slidesLength}}",
            },
            breakpoints: {
                0: { slidesPerView: 1.5, spaceBetween: 16 },
                768: { slidesPerView: 3, spaceBetween: 21 },
                1201: { slidesPerView: 4, spaceBetween: 21 },
            },
        });
    });
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initRelatedItems);
} else {
    initRelatedItems();
}
